export const campAcceptRejectTranslations = {
    en: {
        // Validation Messages
        nameMinLength: "Name must be at least 2 characters",
        nameRequired: "Name is required",
        mobileValidation: "Mobile number must be numbers only and 10 digits long",
        mobileRequired: "Mobile number is required",
        invalidEmail: "Invalid email address",
        emailRequired: "Email is required",
        atLeastOneCoordinator: "At least one coordinator is required",
        rejectionReasonRequired: "Rejection reason is required",

        // Initial State
        actionRequired: "Action Required",
        reviewInstructions: "Please review the camp information carefully. You can accept the camp request or reject it if the details are incorrect.",
        acceptCamp: "Accept Camp",
        rejectCamp: "Reject Camp",

        // Accept State
        coordinatorDetails: "Coordinator Details",
        skipCoordinators: "Skip adding coordinators",
        addAnother: "Add Another",
        coordinatorNumber: "COORDINATOR",
        removeCoordinator: "Remove Coordinator",
        name: "Name *",
        namePlaceholder: "Full Name",
        mobile: "Mobile *",
        mobilePlaceholder: "10-digit number",
        email: "Email *",
        emailPlaceholder: "Email address",
        skipMessage: "You are choosing to accept this camp without adding coordinator details.",
        cancel: "Cancel",
        acceptWithoutCoordinators: "Accept without Coordinators",
        submitAccept: "Submit & Accept",

        // Reject State
        rejectionInstruction: "Please provide a reason for rejecting this camp. This information will be shared with the organizer.",
        rejectionReason: "Rejection Reason *",
        rejectionPlaceholder: "Type your reason here...",
        confirmRejection: "Confirm Rejection",

        // Messages
        updateSuccess: "Camp status updated successfully",
        updateFailed: "Failed to update camp status",
    },
    mr: {
        // Validation Messages
        nameMinLength: "नाव किमान २ अक्षरांचे असावे",
        nameRequired: "नाव आवश्यक आहे",
        mobileValidation: "मोबाइल नंबर फक्त अंक असावा आणि १० अंकांचा असावा",
        mobileRequired: "मोबाइल नंबर आवश्यक आहे",
        invalidEmail: "अवैध ईमेल पत्ता",
        emailRequired: "ईमेल आवश्यक आहे",
        atLeastOneCoordinator: "किमान एक समन्वयक आवश्यक आहे",
        rejectionReasonRequired: "नाकारण्याचे कारण आवश्यक आहे",

        // Initial State
        actionRequired: "कृती आवश्यक",
        reviewInstructions: "कृपया मोहिमेची माहिती काळजीपूर्वक पहा. तपशील चुकीचे असल्यास तुम्ही मोहीम स्वीकारू किंवा नाकारू शकता.",
        acceptCamp: "मोहीम स्वीकारा",
        rejectCamp: "मोहीम नाकारा",

        // Accept State
        coordinatorDetails: "समन्वयक तपशील",
        skipCoordinators: "समन्वयक जोडणे वगळा",
        addAnother: "आणखी जोडा",
        coordinatorNumber: "समन्वयक",
        removeCoordinator: "समन्वयक काढा",
        name: "नाव *",
        namePlaceholder: "पूर्ण नाव",
        mobile: "मोबाइल *",
        mobilePlaceholder: "१०-अंकी नंबर",
        email: "ईमेल *",
        emailPlaceholder: "ईमेल पत्ता",
        skipMessage: "तुम्ही समन्वयक तपशील न जोडता ही मोहीम स्वीकारण्याचा निर्णय घेत आहात.",
        cancel: "रद्द करा",
        acceptWithoutCoordinators: "समन्वयकांशिवाय स्वीकारा",
        submitAccept: "सबमिट करा आणि स्वीकारा",

        // Reject State
        rejectionInstruction: "कृपया ही मोहीम नाकारण्याचे कारण द्या. ही माहिती आयोजकासोबत शेअर केली जाईल.",
        rejectionReason: "नाकारण्याचे कारण *",
        rejectionPlaceholder: "तुमचे कारण येथे टाइप करा...",
        confirmRejection: "नाकारणे निश्चित करा",

        // Messages
        updateSuccess: "मोहीम स्थिती यशस्वीरित्या अद्यतनित केली",
        updateFailed: "मोहीम स्थिती अद्यतनित करण्यात अयशस्वी",
    }
};
